import React from 'react';
interface SectionMarkerProps {
  className?: string;
}
export function SectionMarker({
  className = ''
}: SectionMarkerProps) {
  return <span className={`inline-block w-3 h-3 rounded-full bg-blue-marker ${className}`} data-id="element-237" />;
}